import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { APP_BASE_HREF } from '@angular/common';
import { NavegacaoModule } from './navegacao/navegacao.module';
import { AppRoutingModule } from './app-routing.module';
import { ContaModule } from './conta/conta.module';
//import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { jqxGridModule }    from 'jqwidgets-ng/jqxgrid';
import { jqxWindowModule }    from 'jqwidgets-ng/jqxwindow';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './local-interceptors/auth.interceptor';
import { EditarComponent } from './questao/editar/editar.component';
import { QuestaoModule } from './questao/questao.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
//



@NgModule({
  declarations: [
    AppComponent
    
 
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NavegacaoModule,
    ContaModule,
    QuestaoModule,
    NgbPaginationModule, 
    NgbAlertModule,
    //NgxPaginationModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-left',
      preventDuplicates: true,
    }),
    jqxGridModule,
    jqxWindowModule,
    NgbModule
  ],
  providers: [
    AuthInterceptor,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
    // { provide: APP_BASE_HREF, useValue: '/' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
